import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Box from '@mui/material/Box';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
interface BasicDatePickerProps {
  onChange: (value: Date | null) => void;
  label?: string;
  changeValue?: any;
  clearDate?: boolean;
  clearAppointmentDate?: () => void;
}
const PrimaryDatePicker: React.FC<BasicDatePickerProps> = ({
  onChange,
  changeValue,
  clearDate,
  clearAppointmentDate,
}) => {
  // console.log("'DD/MM/YYYY'",  clearDate)
  const [initialDate, setInitialDate] = React.useState(
    !clearDate ? changeValue ? changeValue : dayjs() : null
  );
  const handleDateChange = (value: any) => {
    setInitialDate(value);
    onChange(value);
  };
  const [cleared, setCleared] = React.useState<boolean>(false);
  const clearAppointmentsDate = async (value: any) => {
    setCleared(true)
    if (clearAppointmentDate)
      clearAppointmentDate();
  }
  React.useEffect(() => {
    if (clearDate)
      setCleared(true)
  }, [clearDate])
  React.useEffect(() => {
    if (cleared) {
      const timeout = setTimeout(() => {
        setCleared(false);
      }, 1500);
      return () => clearTimeout(timeout);
    }
    return () => { };
  }, [cleared]);
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        <DesktopDatePicker
          value={initialDate}
          onChange={handleDateChange}
          format="DD.MM.YYYY"
          sx={{
            "& fieldset": {
              border: "none",
            },
            "& .MuiInputBase-root": {
              height: "38px",
              fontSize: "12px",
              overflow: "hidden",
            },
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#F5F5FB",
            },
            width: "100%",
          }}
          slotProps={{
            field: { clearable: true, onClear: clearAppointmentsDate },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};
export default PrimaryDatePicker;